import React, { useEffect, useRef } from 'react';

export const ResultPage = React.memo(() => {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    document.title = 'Confirmation - Formulaire de contact - FranceConnect';
    titleRef.current?.focus();
  }, []);

  return (
    <div className="fr-alert fr-alert--success" role="status">
      <h1
        ref={titleRef}
        aria-describedby="confirmation-details"
        className="fr-alert__title fr-h3 fc-alert-title-focusable"
        data-testid="confirmation-title"
        tabIndex={-1}>
        Votre demande a bien été prise en compte
      </h1>
      <p id="confirmation-details">
        Vous allez recevoir un message de confirmation à l’adresse électronique indiquée dans le
        formulaire de contact. Vous pouvez fermer cette page.
      </p>
    </div>
  );
});

ResultPage.displayName = 'ResultPage';
